<template>
    <div class="position-box">
        <div class="cotainer">
          <div class="wrap-tab" id="content">
              <div class="header head-market">
                <div class="text">{{$t('footer.quotation')}}</div>
              </div>
              <div class="scroll">
                <ul class="legal_ul">
                    <li v-for="item in tabList" :key="item.type" 
                    :class="['old',{ 'wrap-btm': type == item.type}]" 
                    @click="choose(item.id,item.type)">
                        {{item.name}}
                    </li>
                </ul>
              </div>
              <div class="tab-box">
                  <div class="tab tab1">
                      <div class="text">{{$t('mk.name')}}</div>
                      <img class="icon" src="@/assets/Quotations_Sifting.png" v-show="nameIdx == 0" alt="" @click="sortClick('name',1,'up','name')">
                      <img class="icon" src="@/assets/Quotations_Sifting_Up.png" alt=""  v-show="nameIdx == 1" @click="sortClick('name',2,'down','name')">
                      <img class="icon" src="@/assets/Quotations_Sifting_down.png" alt=""  v-show="nameIdx == 2" @click="sortClick('',0,'','name')">
                  </div>
                  <div class="tab tab2">
                      <div class="text">{{$t('mk.newPrice')}}</div>
                      <img class="icon" src="@/assets/Quotations_Sifting.png" v-show="newPriceIdx == 0" alt="" @click="sortClick('new_price',1,'up','new_price')">
                      <img class="icon" src="@/assets/Quotations_Sifting_Up.png" alt=""  v-show="newPriceIdx == 1" @click="sortClick('new_price',2,'down','new_price')">
                      <img class="icon" src="@/assets/Quotations_Sifting_down.png" alt=""  v-show="newPriceIdx == 2" @click="sortClick('',0,'','new_price')">
                  </div>
                  <div class="tab tab3">
                      <div class="text">{{$t('mk.rank')}}</div>
                      <img class="icon" src="@/assets/Quotations_Sifting.png" v-show="changeIdx == 0" alt="" @click="sortClick('change',1,'up','change')">
                      <img class="icon" src="@/assets/Quotations_Sifting_Up.png" alt=""  v-show="changeIdx == 1" @click="sortClick('change',2,'down','change')">
                      <img class="icon" src="@/assets/Quotations_Sifting_down.png" alt=""  v-show="changeIdx == 2" @click="sortClick('',0,'','change')">
                  </div>
              </div>
              <ul class="table-body">
                  <li class="tr" v-for="(item, index) in detailList" :key="index" @click="jump(item.symbol,item.type)">
                      <div class="item coin">
                          <img class="icon" v-if="item.type == 1 && selectId == 2" :src="item.icon" alt="">
                          <div class="t1">{{item.name}}/<span class="t2">USDT</span></div>
                      </div>
                      <div class="item price text-center">{{item.new_price || 0.00 | toFixed4}}</div>
                      <div class="item change text-right"><span class="persent" :class="{'bg-red': item.grow < 0}">{{item.grow || 0.000 | toFixed2}}%</span></div>
                  </li>
              </ul>
          </div>
        </div>
        <nav-bar :navName="'quotes'"></nav-bar>
    </div>
</template>

<script>
import navBar from '@/components/NavBar.vue'
let that = this;
export default {
    name: 'quotes',
    data () {
        return {
            tabList: [
                {
                    name: this.$t('hyjy.zx'),
                    id: 0,
                    type: 0
                },
                {
                    name: this.$t('langNew.gjs'),
                    id: 2,
                    type: 2
                },
                {
                    name: this.$t('langNew.yy'),
                    id: 2,
                    type: 3
                },
                {
                    name: this.$t('langNew.szhb'),
                    id: 2,
                    type: 1
                },
            ],
            detailList: [],
            selectId: 2,
            voltxt: '24H量',
            sort: '',
            updown: '',
            nameIdx: 0,
            newPriceIdx: 0,
            changeIdx: 0,
            type: 2,
            timer: null,
            websock: null,
            currencyList: []
        }
    },
    beforeCreate(){
        that = this;
    },
    created(){

    },
    mounted() {
        this.currencyQuotationSuccess();
        this.initWebSocket();
        this.getmarketList(true)
    },
    methods: {
       getmarketList(layer_loading) {
            var that = this;
            let params = {
                type: that.type,
                id:that.selectId,
                sort:that.sort,
                updown:that.updown,
                layer_loading: layer_loading
            }
            this.$ajax.get('/web/getmarketList',{params}).then((res) => {
                let resData = res.data.data;
                var curr;
                if(res.data.code == 1000){
                  setTimeout(()=>{
                    this.$router.push('/login');
                  },1000)
                  return false
                }
                that.detailList = resData;
                that.currencyList = [];
                for (curr in resData){
                    that.currencyList[that.detailList[curr].currency_name.toLowerCase()] = [that.detailList[curr].icon,that.detailList[curr].symbol] ;
                }
            }).catch(function(err){
                console.log(err)
            })
        },
        initWebSocket(){ //初始化weosocket
            const wsuri = this.socket_url;
            this.websock = new WebSocket(wsuri);
            this.websock.onmessage = this.websocketonmessage;
            this.websock.onopen = this.websocketonopen;
            this.websock.onerror = this.websocketonerror;
            this.websock.onclose = this.websocketclose;
        },
        websocketonopen(){ //连接建立之后执行send方法发送数据
        },
        websocketonerror(){//连接建立失败重连
            this.initWebSocket();
        },
        websocketonmessage(e){ //数据接收
            if(JSON.parse(e.data).action == "marketprice"){
                let msg = JSON.parse(e.data).content;
                let keyArr = [];
                for(var x in this.currencyList){
                    for(var y in this.detailList){
                      if(!msg[x]) return;
                      if(msg[x].currency_name == this.detailList[y].currency_name){
                          this.detailList[y]['new_price'] = msg[x].now_price;
                          this.detailList[y]['grow'] = msg[x].change;
                          keyArr.push(this.detailList[y]);
                          break;
                      }
                    }
                }
                this.detailList = keyArr;
            }
        },
        websocketsend(Data){//数据发送
            this.websock.send(Data);
        },
        websocketclose(e){  //关闭
            // console.log('断开连接',e);
        },
        choose(id,type) {
            this.selectId = id;
            this.type = type;
            this.getmarketList(false)
        },
        currencyQuotationSuccess(res) {
            let that = this;
            that.tabList = [
                {
                    name: this.$t('hyjy.zx'),
                    id: 0,
                    type: 0
                },
                {
                    name: this.$t('langNew.gjs'),
                    id: 2,
                    type: 2
                },
                {
                    name: this.$t('langNew.yy'),
                    id: 2,
                    type: 3
                },
                {
                    name: this.$t('langNew.szhb'),
                    id: 2,
                    type: 1
                },
            ];
            that.selectId = 2
        },
        sortClick(obj,idx,updown,type){
            if(type == 'name'){
                this.newPriceIdx = 0;
                this.changeIdx = 0;
                this.nameIdx = idx;
                this.sort = obj;
                this.updown = updown;
            }else if(type == 'new_price'){
                this.nameIdx = 0;
                this.changeIdx = 0;
                this.newPriceIdx = idx;
                this.sort = obj;
                this.updown = updown;
            }else{
                this.nameIdx = 0;
                this.newPriceIdx = 0;
                this.changeIdx = idx;
                this.sort = obj;
                this.updown = updown;
            }
            this.getmarketList(false);
        },
        collect(id, index) {
					var that = this
					var data = {layer_loading: true,id:id};
          this.$ajax.post('/web/addCollectCurrenct',data).then((res) => {
              let resData = res.data;
              if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                if(that.selectId == 2){
                  that.detailList.splice(index,1)
                }else{
                  that.detailList[index].is_collect = !that.detailList[index].is_collect
                }
              }else{

                this.$toast.center(resData.message);
                return;
              }
          }).catch(function(err){
              console.log(err)
          })
					_ajax('web/addCollectCurrenct', 'post', data, function(res){
						if(that.selectId == 2){
							that.detailList.splice(index,1)
						}else{
							that.detailList[index].is_collect = !that.detailList[index].is_collect
						}
					})
				},
        jump(symbol,type){
          if(type == 1){
            this.$router.push({ path: '/contractTransaction', query: { symbol: symbol } })
          }else{
            this.$router.push({ path: '/preciousMetal', query: { symbol: symbol } })
          }
        }
    },
    components:{
        navBar,
    },
    beforeDestroy(){
      this.websock.close(); //离开路由之后断开websocket连接
    },
    destroyed() {
      this.websock.close() //离开路由之后断开websocket连接
    }
}
</script>
<style scoped>
    .header{
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        z-index: 100;
        height: 1.5rem;
        padding: 0 .36rem 0;
        font-size: .48rem;
        line-height: 1.5rem;
        background: #f7f7f7;
        text-align: center;
    }
    .header .text{
        color: #000;
    }
    .header .icon{
        width: .6rem;
        height: .6rem;
    }
    .wrap-menu {
        overflow: hidden;
        z-index: 99999;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        background: #FFFFFF;
    }
    .wrap-btm::after {
        position: absolute;
        left: 50%;
        bottom: 0;
        content: '';
        width: 20px;
        height: 2px;
        margin-left: -10px;
        background: #218adc;
    }
    .scroll {
        position: fixed;
        top: 1.5rem;
        left: 0;
        width: 100%;
        z-index: 100;
        padding: 0 .36rem;
        background: #f7f7f7;
        box-sizing: border-box;
        overflow-x: hidden;
    }
    .wrap-tab .legal_ul {
        padding: .18rem 0 .12rem;
        margin: 0 auto;
        display: flex;
        justify-content: space-around;
        overflow-x: scroll;
    }
    .wrap-tab .legal_ul .old{
      width: 25%;
    }
    .wrap-tab .tab-box{
        position: fixed;
        top: 2.7rem;
        z-index: 100;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .6rem .3rem .36rem;
        background: #fff;
        box-sizing: border-box;
    }
    .wrap-tab .tab-box .tab{
        display: flex;
        align-items: center;
        color: #7f7f7f;
        font-size: .4rem;
    }
    .wrap-tab .tab-box .tab1{
        flex: 1;
    }
    .wrap-tab .tab-box .tab2{
        justify-content: center;
        flex: 1;
    }
    .wrap-tab .tab-box .tab3{
        justify-content: flex-end;
        flex: 1;
        text-align: right;
    }
    .wrap-tab .tab-box .icon{
        margin-left: .12rem;
        width: .3rem;
        height: .48rem;
    }
    .wrap-tab ul li {
        position: relative;
        font-size: .48rem;
        color: #7f7f7f;
        height: .9rem;
        line-height: .9rem;
        /* padding: 0 .6rem; */
        text-align: center;
    }
    .cotainer .table-body{
        position: absolute;
        top: 4rem;
        bottom: 2.1rem;
        width: 100%;
        padding: 0 .4rem;
        background: #fff;
        box-sizing: border-box;
        overflow-y: scroll;
    }
    .cotainer .table-body .tr{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .4rem 0;
        border-bottom: 1px solid #eee;
    }
    .cotainer .table-body .tr .item{
        width: 33.33%;
    }
    .cotainer .table-body .coin{
        display: flex;
        align-items: center;
    }
    .cotainer .table-body .coin .icon{
        width: .94rem;
        height: .94rem;
        margin-right: .3rem;
    }
    .cotainer .table-body .coin .t1{
        color: #000;
        font-size: .38rem;
    }
    .cotainer .table-body .coin .t2{
        color: #b0b0b0;
        font-size: .32rem;
    }
    .cotainer .table-body .price{
        color: #000;
        font-size: .48rem;
    }
    .cotainer .table-body .change .persent{
        display: inline-block;
        width: 2rem;
        padding: 3px 6px;
        color: #fff;
        border-radius: 4px;
        background: #00c483;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/pages/quotes.vue